<form #form="ngForm" class="app-grid">
    <ng-container *ngIf="deduction">
        <div class="columns-6 app-grid">
            <mat-form-field>
                <mat-label appRemoveAriaOwns>{{ 'payroll.deductions.type' | translate }}</mat-label>
                <mat-select
                    required
                    name="deductionTypeId"
                    #deductionTypeId="ngModel"
                    [(ngModel)]="deduction.deductionTypeId"
                    (ngModelChange)="deductionTypeChange.emit($event)"
                    [disabled]="deduction.id"
                >
                    <mat-option *ngFor="let type of deductionTypes" [value]="type.id">{{
                        type.displayName
                    }}</mat-option>
                </mat-select>
                <mat-error *ngIf="deductionTypeId.invalid">{{ deductionTypeId.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'payroll.deductions.name' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    name="name"
                    required
                    #name="ngModel"
                    [(ngModel)]="deduction.name"
                    placeholder="Exec Health"
                />
                <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{ 'payroll.deductions.glCodePayable' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    name="glCodePayable"
                    #glCodePayable="ngModel"
                    [(ngModel)]="deduction.glCodePayable"
                    placeholder="1001002"
                />
                <mat-error *ngIf="glCodePayable.invalid">{{ glCodePayable.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </ng-container>
</form>
